<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Maggie Moor is the author of <em>I Am: Your Guide to Mind and Body Union for Total Awareness</em>, and her psychoanalytic paper, <em>Coloring Outside the Lines: Sadomasochistic Defense and the Search for Identity,</em> was nominated for the NAAP Gradiva Award. She lives in New York City, where she is a licensed psychoanalyst and works with people recovering from trauma and addiction. Maggie is also a three-time national figure competitor and a jazz-rock singer/songwriter. She has recorded three albums with Grammy-award-winning musicians. <em>Skinless: The Story of a Female Survivor</em> is Maggie Moor’s first fiction novel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ed91005c